import React from 'react';
import Slider from 'react-slick';
import { routes } from '../../../routes';
import { Link } from 'react-router-dom';
import { images } from '../../../assets/images'
import { Animated } from 'react-animated-css';
import { renderImage } from '../../../Components/helper/image';
import { charLimit, stripTags } from '../../../Components/helper/General';


function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
}

function ArticlesSlider(props) {
    var settings = {
        autoplay: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    };
    return (
        <div className="articles_items">
            <Slider {...settings}>
            {props.item && props.item.articles.map((item, index) => (
                <div key={index} className="article_item">
                    <Animated animationIn="fadeInUp" animationInDuration={500} animationInDelay={3200} isVisible={true}>
                        <div className="article_img embed-responsive embed-responsive-4by3">
                            <img src={renderImage(item.image,'large')} alt="..." className="img-fluid d-block mx-auto embed-responsive-item" />
                        </div>
                        <div className="article_content text-center">
                            <h4>
                                <Link to={routes}>{item.title}</Link>
                            </h4>
                            <p>
                            {charLimit(stripTags(item.description), 225) }
                        </p>
                            {props.item.is_button === 1 ? <div className="secondary_btn">
                                <Link to={props.item.button_link}>{props.item.button_text} <i className="far fa-angle-right ml-2"></i></Link>
                            </div>: null}
                        </div>
                    </Animated>
                </div>
            ))}
            </Slider>
        </div>
    );
}

export { ArticlesSlider };
